import React from 'react';
import { componentSwitcher } from './helpers/componentSwitcher';
import { VisualAid } from './SignUpVisualAid.styles';
import {} from './types/SignUpVisualAid.types';
const SignUpVisualAid = ({ component }) => (React.createElement(VisualAid, null, componentSwitcher(component)));
export default SignUpVisualAid;
